import authentication from '../middleware/authentication'
const SettingAcd = () => import(/* webpackChunkName: "static/js/chunks/Acd" */'../../views/Setting/Acd')
const settingMain = [
  {
    path: '/setting-acd',
    name: 'Acd',
    component: SettingAcd,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  }
]

export default settingMain
